import React from 'react';  
import './App.css';  
  
function Contact() {  
  return (  
    <div className="contact-container">  
      <h1 className="contact-title">Contact Us</h1>  
      <p className="contact-text">  
        Thank you for your interest in Sure Steps Learning! We’d love to hear from you! 
        <br />
        <br />
        For registrations, enquiries or any questions, please reach out to us via email address given below. Whether it’s about our services, term start dates, fees and course details or general information, we’re here to assist you!
      </p>  
      <p >  
        <a className="contact-email" href="mailto:surestepslearning@gmail.com">surestepslearning@gmail.com</a>  
      </p>  
      <p className="contact-text">  
        
      </p>
    </div>  
  );  
}  
  
export default Contact;  